import { SET_ONBOARDING_PROPERTY } from 'store/actions/onboarding';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_ONBOARDING_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  }
};
